<template>
  <div class="article-keyword-tags">
    <div
      class="article-keyword-tags__title-container border-softened border-bottom border-normal mt-2 pb-3 mb-1 mr-2"
    >
      <h2 class="article-keyword-tags__title-text title">Keywords</h2>
    </div>
    <ArticleKeywordTag :article="article" />
  </div>
</template>

<script>
import ArticleKeywordTag from "~/components/articles/components/ArticleKeywordTag.vue";

export default {
  name: "ArticleKeywordTags",
  components: { ArticleKeywordTag },
  props: {
    article: { type: Object, required: true },
  },
};
</script>
